import React from "react";

const NewsShowSkeleton: React.FC = () => {
  return (
    <div className="flex max-md:flex-col gap-10">
      <div className="w-1/2 max-md:w-full p-7">
        <div className="skeleton w-2/3 h-12 !rounded-md mb-10"></div>
        <div className="flex flex-col gap-3">
          {[1, 2, 3, 4, 5, 6].map((item) => {
            return (
              <div className="skeleton w-full h-6 !rounded-md" key={item}></div>
            );
          })}
        </div>
      </div>
      <div className="w-1/2 max-md:w-full">
        <div className="skeleton max-w-[490px] w-[490px] max-xl:w-[430px] max-md:w-[450px] max-sm:w-full h-[560px] !rounded-[20%] max-sm:!rounded-xl max-sm:mx-auto ml-8"></div>
      </div>
    </div>
  );
};

export default NewsShowSkeleton;
